import { Emitter, type Event } from '@patsnap/tahiti-core';

export interface ProjectTitleRefreshedEvent {
    projectId: string;
    title: string;
    actionId: string;
}

export interface ProjectEventSource {
    readonly onTitleRefreshed: Event<ProjectTitleRefreshedEvent>;
}

export interface ProjectEventPublisher {
    /** 发布项目标题刷新完成事实。 */
    publishTitleRefreshed(event: ProjectTitleRefreshedEvent): void;
}

/** 创建可隔离测试的项目领域事件服务。 */
export function createProjectEvents(): ProjectEventSource & ProjectEventPublisher {
    const titleRefreshedEmitter = new Emitter<ProjectTitleRefreshedEvent>({
        onListenerError: error => console.error('[ProjectEvents] listener failed:', error),
    });
    return {
        onTitleRefreshed: titleRefreshedEmitter.event,
        publishTitleRefreshed: event => titleRefreshedEmitter.fire(event),
    };
}

/** 应用级项目领域事件服务。 */
export const projectEvents = createProjectEvents();
